import React, { ReactElement } from 'react';
import { PrivateDotIcon, PublicDotIcon, RenderDotsWrapper, SmallDotIcon } from '../../components/common/CommonStyle';

interface ItemProps {
  order: number;
  image: string;
  private: boolean;
  privateReal: boolean;
  type: string;
  total: number;
}

interface Photo {
  order: number;
  image: string;
  private: boolean;
  privateReal: boolean;
  type: string;
  total: number;
  status: string;
}

const ProfileMediaRenderDots = React.forwardRef(
  (
    {
      item,
      index,
      currentSlide,
      photos,
    }: {
      item: ItemProps;
      index: number;
      currentSlide: number;
      photos: Photo[];
    },
    ref
  ): ReactElement => {
    const activeDot = currentSlide === index;
    const lastDotSmall = photos.length >= 4 && index > currentSlide + 2;
    const hideDots = photos.length >= 4 && (index > currentSlide + 3 || index < currentSlide - 3);
    const firstDotSmall = photos.length >= 4 && index < currentSlide - 2;

    const renderDots = () => {
      if (lastDotSmall || firstDotSmall) {
        return hideDots ? (
          <></>
        ) : (
          <SmallDotIcon
            // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
            key={`small-${index}-${item.path}`}
            isPublic={!(item.private || item.privateReal)}
          />
        );
      } else if (!item.private && !item.privateReal) {
        return <PublicDotIcon key={`public-${index}`} activeDot={activeDot} />;
      } else {
        return <PrivateDotIcon key={`private-${index}`} activeDot={activeDot} />;
      }
    };

    return (
      <RenderDotsWrapper
        // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
        ref={ref}
        hideDots={hideDots}
        key={`${index}`}
        data-test-id={`${index}`}
      >
        {renderDots()}
      </RenderDotsWrapper>
    );
  }
);

export default React.memo(ProfileMediaRenderDots);
